import { Box, Button, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { formatarMonetárioParaNúmero, formatarValorMonetario } from "../../../../../../../../../../helpers/masks";
import { useMemo, useState } from "react";
import DialogCadastrarPag from "./DialogCadastrarPag";
// import DialogCadastrarRecb from "./DialogCadastrarRecb";

export default function Pagamento() {

    const { watch, getValues, setValue } = useFormContext();

    const valuePag = watch('finalizacao.pagamentos')

    const [openModal, setOpenModal] = useState<IOpenModal>({
        state: false,
        preValue: null
    })

    //funções manipuladoras
    const handleOpenModal = (value: number | null = null) => {
        setOpenModal({
            state: true,
            preValue: value
        })
    }

    const handleCloseModal = () => {
        setOpenModal({
            state: false,
            preValue: null
        })
    }

    const handleRemoveItem = (index: number) => {
        const valoresPag = getValues('finalizacao.pagamentos')
        valoresPag.splice(index, 1);
        setValue('finalizacao.pagamentos', valoresPag)
    }
    //

    //valores importantes
    const valorTotal = useMemo(() => valuePag.reduce((acumulador: number, item: any) =>
        acumulador + formatarMonetárioParaNúmero(item.valor), 0
    ), [valuePag])
    //

    return (
        <Box mt={2}>
            {
                (valuePag.length <= 0) && (
                    <Box
                        display="flex"
                        alignItems="center"
                        flexDirection="column"
                        justifyContent="center"
                        borderRadius={1}
                        height={200}
                        border="1px solid #1B5E20"
                        gap={0.5}
                    >
                        <Typography variant="subtitle2">Clique no botão abaixo para adicionar os valores pagos</Typography>
                        <Typography variant="caption" mb={1}>(Ex: Dinheiro, PIX, Cartão de Crédito, etc..)</Typography>
                        <Button size="small" variant="contained" startIcon={<AddIcon />} onClick={() => handleOpenModal()}>
                            Adicionar
                        </Button>
                    </Box>
                )
            }

            {
                (valuePag.length > 0) &&
                <>
                    <Box mb={1} display="flex" alignItems="center" justifyContent="space-between">
                        <Typography variant="h6">Valores</Typography>

                        <Button size="small" variant="contained" startIcon={<AddIcon />} onClick={() => handleOpenModal()}>
                            Adicionar
                        </Button>
                    </Box>

                    <TableContainer sx={{ border: "1px solid #ccc", borderRadius: 2 }}>
                        <Table size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell><b>Forma de pagamento</b></TableCell>
                                    <TableCell align="right"><b>Valor</b></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    valuePag.map((item: any, index: number) => {
                                        return (
                                            <TableRow
                                                key={index}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell component="th" scope="row">
                                                    {item.formaPagamento?.label ?? "-"}<br />
                                                    {item.nsu ? `NSU: ${item.nsu} - ` : ""}{item.autorizacao ? `Autorizacao: ${item.autorizacao}` : ""}
                                                </TableCell>

                                                <TableCell align="right">
                                                    {item.valor}
                                                </TableCell>

                                                <TableCell align="right">
                                                    <Box display="flex" gap={0.5} justifyContent="flex-end">
                                                        <IconButton aria-label="edit" size="small" onClick={() => handleOpenModal(index)}>
                                                            <EditIcon fontSize="inherit" />
                                                        </IconButton>

                                                        <IconButton aria-label="delete" size="small" color="error" onClick={() => handleRemoveItem(index)}>
                                                            <DeleteIcon fontSize="inherit" />
                                                        </IconButton>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                }

                                <TableRow
                                    sx={{
                                        bgcolor: "#E8E8E8",
                                        '&:last-child td, &:last-child th': { border: 0 }
                                    }}
                                >
                                    <TableCell
                                        component="th"
                                        scope="row"
                                    >
                                        <b>Valor total</b>
                                    </TableCell>

                                    <TableCell
                                        colSpan={2}
                                        align="right"
                                    >
                                        <b>{formatarValorMonetario(valorTotal)}</b>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            }

            {
                openModal.state &&
                <DialogCadastrarPag
                    open={openModal.state}
                    value={openModal.preValue}
                    handleClose={() => handleCloseModal()}
                />
            }
        </Box>
    )
}

interface IOpenModal {
    state: boolean,
    preValue: number | null
}